// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__bCtL3","buttons":"Footer_buttons__hdlZx"};